import offlineService from './offline';

const API_BASE_URL = '/api/cafe';

const isMutation = (method) => ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method);

class CafeService {
  getToken() {
    return localStorage.getItem('auth_token');
  }

  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = this.getToken();
    const config = {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (config.body && typeof config.body === 'object' && !(config.body instanceof FormData)) {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      if (!response.ok) {
        if (response.status === 401 && data.error && data.error.includes('Token expired')) {
          window.dispatchEvent(new CustomEvent('auth:token-expired'));
        }
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
      if (!isMutation(options.method)) {
        offlineService.setCached(url, data).catch(() => {});
      }
      return data;
    } catch (error) {
      if (error instanceof TypeError && error.message.includes('fetch')) {
        const method = options.method || 'GET';
        if (isMutation(method)) {
          const bodyData = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
          await offlineService.queueMutation(method, url, bodyData);
          return { _offline: true, _queued: true, message: 'Data akan dikirim saat koneksi kembali' };
        } else {
          const cached = await offlineService.getCached(url);
          if (cached) return cached;
        }
      }
      console.error('Cafe API request failed:', error);
      throw error;
    }
  }

  // Dashboard
  async getDashboard() {
    return this.request('/dashboard');
  }

  // Products
  async getProducts(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/products${query ? `?${query}` : ''}`);
  }

  async createProduct(data) {
    return this.request('/products', {
      method: 'POST',
      body: data,
    });
  }

  async updateProduct(id, data) {
    return this.request(`/products/${id}`, {
      method: 'PUT',
      body: data,
    });
  }

  async deleteProduct(id) {
    return this.request(`/products/${id}`, {
      method: 'DELETE',
    });
  }

  // Sales (POS)
  async createSale(data) {
    return this.request('/sales', {
      method: 'POST',
      body: data,
    });
  }

  async getSales(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/sales${query ? `?${query}` : ''}`);
  }

  async getSalesReport(params = {}) {
    const query = new URLSearchParams(params).toString();
    return this.request(`/sales/report${query ? `?${query}` : ''}`);
  }

  async voidSale(id, reason = '') {
    return this.request(`/sales/${id}/void`, {
      method: 'POST',
      body: { reason },
    });
  }
}

export const cafeService = new CafeService();
export default cafeService;
